import { render, staticRenderFns } from "./ebs-main.vue?vue&type=template&id=eadd0252&"
import script from "./ebs-main.vue?vue&type=script&lang=js&"
export * from "./ebs-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports